function isMobileDevice() {
  const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0, userAgent = navigator.userAgent || navigator.vendor || window.opera, isMobileUserAgent = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  return hasTouch && isMobileUserAgent;
}
export {
  isMobileDevice
};
//# sourceMappingURL=isMobileDevice.js.map
